import React, { Component } from "react";
import InputMask from 'react-input-mask';

class FormFirstStepCpf extends Component {
  render() {
    return (
      <div className="form">
        <p>Finalizar seu cadastro em</p>
        <h1>{this.props.companyName}</h1>
        <form className="verify" onSubmit={this.props.onSubmit}>
          <InputMask mask="999.999.999-99" placeholder="CPF" name="cpf" required />
          <button type="submit">Avançar</button>
        </form>
      </div>
    )
  }
}

export default FormFirstStepCpf;




// WEBPACK FOOTER //
// ./src/app/home/container/formFirstStepCpf.js